export default __webpack_public_path__ + "static/media/QUIEN.9d6f4ec6.jpg";